import styled from '@emotion/styled';
import * as React from 'react';

import { Icon } from '@travelnest/merlin.icon';
import { Spacer } from '@travelnest/merlin.spacer';
import theme from '@travelnest/merlin.theme';
import { HeadingSmall } from '@travelnest/merlin.typography';

import { Accordion, AccordionHeader, AccordionItem } from '../../components/accordion';
import { CalendarSync } from '../../components/calendar-sync/CalendarSyncContainer';
import { BreakpointType } from './Calendar';
import { DateRangeSelectors } from './DateRangeSelectors';

const FakeAccordionSeparator = styled.div`
	border-bottom: 1px solid var(--colour-border);
	width: calc(100% + 2rem);

	@media screen and (max-width: 768px) {
		margin: 0 -1rem 0 -1rem;
	}
`;

const IconWrap = styled.div`
	margin-right: 10px;
	width: 30px;
	background-color: ${theme.colours.neutral.medium};
	border-radius: 50%;
`;

interface ICalendarSettingsProps {
	propertyId: string | number | undefined;
	breakpoint: BreakpointType;
	isAdmin?: boolean;
	onCalSelectionChange: (s: Date[]) => any;
	setCurrentMonth: (m: Date) => any;
}

export const CalendarSettings: React.FC<ICalendarSettingsProps> = ({ propertyId,  breakpoint, isAdmin, onCalSelectionChange, setCurrentMonth }) => {
	return <div id="calendar-settings">
		<Accordion>
			<AccordionHeader
				collapsible={true}
				startCollapsed={isAdmin !== true}
				icon={() => <IconWrap><Icon icon="cog" colour="white" /></IconWrap>}
				headingSize="small"
				topRule
				subheading="Select a larger date range and view calendar sync"
				breakpoint={breakpoint}>
					Additional calendar features
			</AccordionHeader>
			<AccordionItem>
				<>
					<HeadingSmall>Block a large date range</HeadingSmall>
					<Spacer spacing="large" />
					<DateRangeSelectors onCalSelectionChange={onCalSelectionChange} setCurrentMonth={setCurrentMonth} breakpoint={breakpoint} />
					<FakeAccordionSeparator />
					<Spacer />
					{ !!propertyId && <>
						<HeadingSmall>Calendar sync</HeadingSmall>
						<Spacer spacing="large" />
						<CalendarSync propertyId={propertyId!} />
					</>}
				</>
			</AccordionItem>
		</Accordion>
	</div>;
};
